export default "__VITE_ASSET__qNEzp7qB__"